
import {useMediaQuery} from "react-responsive";


export function PurchaseBodyHeader() {
    const isDesktop = useMediaQuery({query: '(min-width: 800px)'})
    return (
        <thead >
        <tr  >
            <th  className=" text-center invoice-head-cell bg-warning border-round-md shadow m-1 " scope="col">+</th>
            <th  className="  text-start invoice-head-cell bg-warning border-round-md shadow " scope="col">Description</th>
            <th  className="  text-end invoice-head-cell bg-warning border-round-md shadow " scope="col">Qty</th>
            <th  className=" text-end align-items-center justify-content-end invoice-head-cell bg-warning border-round-md shadow " scope="col">Amount</th>
            <th  className="  text-end invoice-head-cell bg-warning border-round-md shadow " scope="col">Total</th>
            {isDesktop&&<th  className="text-start invoice-head-cell bg-warning border-round-md shadow " scope="col">Comment</th>}
            <th  className=" text-center invoice-head-cell bg-warning border-round-md shadow m-1 " scope="col">-</th>
        </tr>
        </thead>

    )
}
